export function pickedFile(input) {
  if (!input) return null
  if (typeof File !== 'undefined' && input instanceof File) return input
  return input.target?.files?.[0] || null
}
